import { useEffect, useMemo, useState } from "react";
import Layout from "components/layout";
import {
  ArrowRightIcon2,
  ArrowRightIcon,
  ArrowLeftIcon2,
  BusIcon,
} from "assets/icons";
import BusFilters from "./busFilters";
import Tickets from "./Tickets";
import { SearchBuses } from "sections";

function SearchBusesSection() {
  const [openFilters, setOpenFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    sortByPrice: "",
    operatorList: 0,
    facilityList: [],
  });

  const [searchResults, setSearchResults] = useState([]);

  const [tripDate, setTripDate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (openFilters) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [openFilters]);

  return (
    <Layout showMobileHeader={false} showBottomTab={false}>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex items-center lg:hidden bg-primary-700 py-2.5 px-5 mb-7">
          <button className="text-white h-4 w-4 mr-16">
            <ArrowLeftIcon2 />
          </button>
          <div className="flex-1 flex gap-6">
            <div className="text-white">
              <BusIcon />
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <div className="text-sm font-semibold text-white">
                  Kuala Lumpur
                </div>
                <div className="text-white h-3.5 w-3.5 mt-0.5">
                  <ArrowRightIcon />
                </div>
                <div className="flex flex-col">
                  <div className="text-sm font-semibold text-white">
                    Johor Bahru
                  </div>
                </div>
              </div>
              <div className="text-sm text-white font-medium">
                Sun, 02 April 2024
              </div>
            </div>
          </div>
          <button className="text-sm font-medium text-white">Change</button>
        </div>
        <div className="w-full max-w-8xl margins">
          <div className="mt-10 mb-8 hidden lg:flex items-center gap-2">
            <div className="text-sm text-[#112211] font-semibold">Home</div>
            <ArrowRightIcon2 />
            <div className="text-sm text-primary-700 font-semibold">
              Kuala Lumpur To Johor Bahru Bus Tickets
            </div>
          </div>

          <div className="w-full flex flex-col z-[10]">
            <SearchBuses
              loading={loading}
              setLoading={setLoading}
              selectedFilters={selectedFilters}
              setSearchResults={setSearchResults}
              setTripDate={setTripDate}
            />
          </div>

          <div className="w-full flex gap-8 mb-[60px]">
            {searchResults?.length > 0 && (
              <div
                className={`w-full lg:max-w-[400px] flex flex-col fixed lg:relative left-0 bottom-0 top-0 z-[9999] lg:z-[1] lg:inherit ${
                  openFilters ? "flex lg:flex" : "hidden lg:!flex"
                }`}
              >
                <BusFilters
                  setOpenFilters={setOpenFilters}
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  searchResults={searchResults}
                  setSearchResults={setSearchResults}
                />
              </div>
            )}

            <Tickets
              loading={loading}
              searchResults={searchResults}
              tripDate={tripDate}
              selectedFilters={selectedFilters}
              setOpenFilters={setOpenFilters}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
export default SearchBusesSection;
